import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=ed5d2496&scoped=true&"
import script from "./ForgetPassword.vue?vue&type=script&lang=ts&"
export * from "./ForgetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=ed5d2496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5d2496",
  null
  
)

export default component.exports